var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarOpenTeal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "A9984E16-1040-4876-A0D4-EF42DE81A4E3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web-app",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "web-my-pub",
    transform: "translate(-122, -330)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(98, 306)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Size=24-2",
    transform: "translate(24, 24)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.46421455,25.9602194 L15.7427082,22.1732155 L22.0211619,26.0100484 L20.376805,18.8346727 L25.9078238,14.0510889 L18.6327901,13.4033119 L15.7427082,6.62656814 L12.8526263,13.3534829 L5.5775527,14.0012599 L11.1085715,18.8346727 L9.46421455,25.9602194 Z M15.7427082,25.6879537 L7.98851881,30.3643056 C7.69978966,30.5329269 7.41040277,30.6036841 7.120398,30.5769757 C6.8303733,30.5500681 6.56779441,30.4524032 6.3327012,30.2837819 C6.09764785,30.1151606 5.91623044,29.8947171 5.78846888,29.6226508 C5.6606874,29.3503851 5.64023758,29.0496173 5.72713935,28.7199486 L7.78541581,19.9155633 L0.93970874,13.9896995 C0.684185638,13.7674622 0.521304609,13.5099459 0.451045721,13.2175494 C0.380786834,12.9249535 0.39930329,12.6405296 0.506595088,12.3646762 C0.61392675,12.0886236 0.768536166,11.8631972 0.970403403,11.6881978 C1.17229057,11.512999 1.44826349,11.3987909 1.79832217,11.3449756 L10.8326584,10.555485 L14.3399222,2.24171597 C14.4676838,1.932537 14.6612196,1.70384183 14.9205297,1.55561053 C15.1798398,1.40741909 15.4538993,1.33333333 15.7427082,1.33333333 C16.0313177,1.33333333 16.3053772,1.40741909 16.5648866,1.55561053 C16.8241967,1.70384183 17.0177326,1.932537 17.1454941,2.24171597 L20.6526583,10.555485 L29.6870543,11.3449756 C30.0370532,11.3987909 30.3131058,11.512999 30.5150129,11.6881978 C30.7167207,11.8631972 30.8713899,12.0886236 30.9788213,12.3646762 C31.0860533,12.6405296 31.1045896,12.9249535 31.0342311,13.2175494 C30.9640719,13.5099459 30.8012307,13.7674622 30.5457076,13.9896995 L23.7000005,19.9155633 L25.7581375,28.7199486 C25.8450392,29.0496173 25.824709,29.3503851 25.6969475,29.6226508 C25.5691859,29.8947171 25.387609,30.1151606 25.1526155,30.2837819 C24.9176219,30.4524032 24.6549235,30.5500681 24.3649187,30.5769757 C24.0749139,30.6036841 23.7855071,30.5329269 23.4968975,30.3643056 L15.7427082,25.6879537 Z",
    id: "Shape",
    fill: "#00414B",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarOpenTeal);
export default __webpack_public_path__ + "static/media/star-open-teal.e3a5e5b0a63b4df25879020fc1f42396.svg";
export { ForwardRef as ReactComponent };